import Common from '@/utils/common'
const service = 'crossborder-order-api'

// 查询结算信息
export function querySettleData(data) {
  return Common.createRequest(service, 'query_declaration_application', data)
}
// 查询价格异常订单
export function queryAbnormal(data) {
  return Common.createRequest(service, 'query_abnormal_price_order', data)
}

// 申报申请
export function declareApply(data) {
  return Common.createRequest(service, 'declaration_application', data)
}
// 查询申报日志
export function queryDeclareLog(data) {
  return Common.createRequest(service, 'query_declare_log', data)
}

// 还原文件下载
export function downloadRestore(data) {
  return Common.createDownRequest(service, 'restore_declaration_download', data)
}
// 还原文件模板下载
export function restoreDownload(data) {
  return Common.createDownFileRequest(service, 'restore_download', data)
}
// 交易文件下载
export function downloadOrder(data) {
  return Common.createDownRequest(service, 'order_declaration_download', data)
}
// 交易重新申报下载
export function downloadOriOrder(data) {
  return Common.createDownRequest(service, 'order_declaration_detail_download', data)
}
// 上传文件
export function importFile(data, api) {
  return Common.createUploadFileRequest(service, api, data)
}

// 提交还原申报
export function submitRestore(data) {
  return Common.createRequest(service, 'submit_declaration_restore_files', data)
}
// 提交交易订单申报
export function submitTradeOrder(data) {
  return Common.createRequest(service, 'submit_declaration_order_files', data)
}
// 提交交易订单申报
export function updateDeclarationInfo(data) {
  return Common.createRequest(service, 'update_declaration_info', data)
}

// 重新提交订单申报
export function againTradeInfo(data) {
  return Common.createRequest(service, 'again_upload_declare_order', data)
}

// 重新申报订单查询
export function errorDetail(data) {
  return Common.createRequest(service, 'afresh_declaration', data)
}

// 标记订单是否失效
export function updateOrderStatus(data) {
  return Common.createRequest(service, 'update_trading_order', data)
}

// 重新生成申报单
export function detailSubmit(data) {
  return Common.createRequest(service, 'afresh_declaration_submit', data)
}

// 订单重新申报------单条下载和全部下载，使用的一个接口
export function orderDownload(data){
  return Common.createRequest('crossborder-order-api', 'AGAIN_DECLARE_FILE_ASYNC_QUERY', data)
}

// 订单重新申报------上传
export function orderReupload(data){
  return Common.createUploadRequest('crossborder-order-api', 'AGAIN_DECLARE_FILE_UPLOAD', data)
}

// 订单重新申报------列表查询
export function orderReuploadQuery(data){
  return Common.createRequest('crossborder-order-api', 'QUERY_CROSSBORDER_MER_AGAIN_DECLARE_FILE', data)
}

// 还原文件列表查询
export function restoreUploadQuery(data){
  return Common.createRequest('crossborder-order-api', 'QUERY_DECLARE_INFO_HIS_LIST', data)
}

// 申报文件列表查询
export function restoreOriginQuery(data){
  return Common.createRequest('crossborder-order-api', 'query_mer_verify_file_list', data)
}

export function declareDownload(data){
  return Common.createRequest('crossborder-order-api', 'AGAIN_DECLARE_RESTORE_FILE_ASYNC_QUERY', data)
}

// 申报原文件下载
export function originDownload(data){
  return Common.createDownRequest('crossborder-order-api', 'mer_verify_file_download', data)
}